import { useContext, useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { signoutThunk } from "../../../store/thunks/authThunk";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearRedux } from "../../../store/slices/authSlice";
import { persistor } from "../../../store";

const UserProfile = (props) => {
  const dispatch = useDispatch();
  const { slsToken, slsLIUId, slsRole } = props;
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const logoutSuccessUrl = secureLocalStorage.getItem("logoutSuccessUrl");
  const [remainingTime, setRemainingTime] = useState("");
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  let storeRole = useSelector((state) => state.auth.role);
  let storeToken = useSelector((state) => state.auth.accessToken);
  let storeLIUId = useSelector((state) => state.auth.lIUId);
  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn,
  );
  const userProfileImage = useSelector((state) => state.auth.userInfo);
  const userName = useSelector((state) => state.auth.lIU);
  const userEmpID = useSelector((state) => state.auth.empID);
const expiryDate = storeAccessTokenExpiresOn
  ? new Date(storeAccessTokenExpiresOn).toLocaleTimeString()
  : "";
  const navigateSignIn = () => {
    window.location.href = process.env.REACT_APP_SSO_LOGIN_REDIRECT_URI;
  };
  const handleSignOut = async () => {
    try {
      await dispatch(
        signoutThunk({
          role: storeRole,
          lIUId: storeLIUId,
          token: storeToken,
          accessTokenExpiresOn: storeAccessTokenExpiresOn,
        }),
      ).unwrap();
    } catch (error) {
      console.error("Error during sign out:", error);
    } finally {
      // ✅ Clear persisted redux state
      await persistor.purge();

      // ✅ Clear in-memory redux state
      dispatch(clearRedux());

      // ✅ Optional: only if you store extra things manually
      secureLocalStorage.clear();

      // ✅ Redirect
      window.location.href = "/";
    }
  };

  useEffect(() => {
  if (!storeAccessTokenExpiresOn) return;

  const updateRemaining = () => {
    const now = Date.now();
    const diff = storeAccessTokenExpiresOn - now;

    if (diff <= 0) {
      setRemainingTime("Expired");
      return;
    }

    const minutes = Math.floor(diff / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    setRemainingTime(`${minutes}m ${seconds}s`);
  };

  updateRemaining(); // initial

  const interval = setInterval(updateRemaining, 1000);

  return () => clearInterval(interval);
}, [storeAccessTokenExpiresOn]);

  useEffect(() => {
    const handleOutside = (e) => {
      if (!e.target.closest(".account-menu-wrapper")) {
        setShowAccountMenu(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);
  return (
    <div className="account-menu-wrapper">
      <button
        className="account-btn"
        onClick={() => setShowAccountMenu(!showAccountMenu)}
      >
        <img
          src={
            userProfileImage?.profilePicUrl
              ? process.env.REACT_APP_BACKEND +
                "/images/" +
                userProfileImage?.profilePicUrl
              : process.env.REACT_APP_BACKEND + "/images/dummy.jpg"
          }
          alt={`${userName} (EmpID - ${userEmpID})`}
          className="profile-img"
        />
        <span className="namelinkclass">{userName}</span>
        <div style={{ fontSize: "10px", marginLeft: "10px" }}>
          <div>Expires: {expiryDate}</div>
          <div>Remaining: {remainingTime}</div>
        </div>

        <i
          className={`fa fa-angle-${showAccountMenu ? "up" : "down"} dropdown`}
        ></i>
      </button>

      {showAccountMenu && (
        <div className="account-dropdown">
          {slsToken && <button onClick={handleSignOut}>Logout</button>}
        </div>
      )}
    </div>
  );
};

export default UserProfile;
